module.exports = __webpack_public_path__ + "img/purchased.fc5c9594.png";